import { render, staticRenderFns } from "./OrderHistory.vue?vue&type=template&id=45c670cb"
import script from "./OrderHistory.vue?vue&type=script&lang=js"
export * from "./OrderHistory.vue?vue&type=script&lang=js"
import style0 from "./OrderHistory.vue?vue&type=style&index=0&id=45c670cb&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Btn: require('/home/node/app/components/ui/btn.vue').default,ControllerOrderHistory: require('/home/node/app/node_modules/@gauss/cms-core/lib/components/controllers/user/ControllerOrderHistory.js').default})
